import { render, staticRenderFns } from "./rczl.vue?vue&type=template&id=8100612e&scoped=true&"
import script from "./rczl.vue?vue&type=script&lang=js&"
export * from "./rczl.vue?vue&type=script&lang=js&"
import style0 from "./rczl.vue?vue&type=style&index=0&id=8100612e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8100612e",
  null
  
)

export default component.exports